import { Link } from 'react-router-dom';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionTo?: string;
}

export default function EmptyState({
  icon = 'ri-search-line',
  title,
  description,
  actionLabel,
  onAction,
  actionTo,
}: EmptyStateProps) {
  const buttonClass =
    'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600';

  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-400">
        <i className={`${icon} text-2xl`} />
      </span>
      <h3 className="mt-4 font-heading text-lg font-bold text-foreground-900">{title}</h3>
      {description && <p className="mt-2 max-w-md text-sm text-foreground-500">{description}</p>}
      {actionLabel && onAction && (
        <button type="button" onClick={onAction} className={`mt-5 ${buttonClass}`}>
          <i className="ri-refresh-line text-lg" />
          {actionLabel}
        </button>
      )}
      {actionLabel && !onAction && actionTo && (
        <Link to={actionTo} className={`mt-5 ${buttonClass}`}>
          {actionLabel}
        </Link>
      )}
    </div>
  );
}